import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, take, withLatestFrom } from 'rxjs/operators';

import { ChangeCoverageFeatureFacade } from '@amfam/policy/change-coverage/feature';
import { PolicySelectors } from '@amfam/policy/data-access';
import { FEATURES, VehicleCoveragesFacade } from '@amfam/policy/vehicle-coverages/data-access';
import { userQuery } from '@amfam/shared/user';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { ConfirmationModel, DockingBarService, PageTitleService } from '@amfam/ui-kit';

@Component({
  selector: 'amfam-agent-notification-confirmation',
  templateUrl: './agent-notification-confirmation.component.html',
  styleUrls: ['./agent-notification-confirmation.component.scss'],
  standalone: false
})
export class AgentNotificationConfirmationComponent implements OnInit {
  isPartner: boolean;
  public confirmationData$: Observable<ConfirmationModel> = this.store
    .select(PolicySelectors.selectAutoPolicyById(this.route.snapshot.paramMap.get('id')))
    .pipe(
      withLatestFrom(
        this.store.select(userQuery.selectPrimaryEmail),
        this.store.select(userQuery.selectMyAccountEmail),
        this.store.select(BrandSelectors.selectIsPartner)
      ),
      take(1),
      map(([, , , isPartner]) => {
        const data = {
          confirmation: {
            status: this.copyService.getCopy(`policy.newVehicleEmailSuccessStatusTextPartner`),
            heading: this.copyService.getCopy(
              isPartner
                ? `policy.changeCoverage.updateCoverageAgentNotificationHeaderText`
                : `policy.changeCoverage.updateCoverageAgentNotificationHeaderTextAFI`
            )
          },
          nextSteps: {
            heading: this.copyService.getCopy(
              `policy.changeCoverage.updateCoverageAgentNotificationSubHeader`
            ),
            text: this.copyService.getCopy(
              isPartner
                ? `policy.changeCoverage.updateCoverageAgentNotificationContent`
                : `policy.changeCoverage.updateCoverageAgentNotificationContentAFI`
            )
          }
        };
        return data;
      })
    );
  private changeCoverageText = this.copyService.getCopy('policy.changeCoverage.pageTitle');
  private changeCoveragePageHeader = this.copyService.getCopy('policy.changeCoverage.pageHeader');

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private pageTitle: PageTitleService,
    private dockingBarService: DockingBarService,
    private copyService: CopyService,
    private featureService: FeatureFlagService,
    private vehicleCoverageFacade: VehicleCoveragesFacade,
    private changeCoverageFeatureFacade: ChangeCoverageFeatureFacade
  ) {
    this.store
      .select(BrandSelectors.selectIsPartner)
      .pipe()
      .subscribe(isPartner => {
        this.isPartner = isPartner;
      });
  }

  ngOnInit() {
    this.pageTitle.set(this.changeCoverageText);
    this.dockingBarService.registerHeading(this.changeCoveragePageHeader);
    this.vehicleCoverageFacade.workOrderNumberAndPolicyNumber$
      .pipe(first())
      .subscribe(workNoPolicyNo => {
        if (workNoPolicyNo && workNoPolicyNo.workOrderNumber) {
          if (!this.isPartner)
            this.changeCoverageFeatureFacade.sendAnalytics({
              event: FEATURES.CHANGE,
              pageAnalyticName: 'Quote:SentToAgent:Complete'
            });
          else
            this.changeCoverageFeatureFacade.sendAnalytics({
              event: FEATURES.CHANGE,
              pageAnalyticName: 'Review:SentToAgent'
            });
        } else {
          this.changeCoverageFeatureFacade.sendAnalytics({
            event: FEATURES.CHANGE,
            pageAnalyticName: 'Quote:NeedAgent:SentToAgent:Complete'
          });
        }
      });
  }

  backToOverview() {
    if (this.isPartner) {
      this.changeCoverageFeatureFacade.sendAnalytics({
        event: FEATURES.CHANGE,
        buttonAnalyticName: 'Start:Recalculate'
      });
    }
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['overview']
      })
    );
  }
}
